module.exports = __webpack_public_path__ + "img/CH-img.40c856da.png";